/**
 * Frontend helpers that call our Netlify function proxy.
 * None of these talk to Regrid directly — the proxy adds the API token.
 */

const PROXY_URL = '/.netlify/functions/regrid';

export async function fetchParcelByAddress(query) {
  return callProxy({ mode: 'address', query });
}

export async function fetchParcelByPoint(lat, lon) {
  return callProxy({ mode: 'point', lat, lon });
}

export async function fetchParcelsByPolygon(polygonFeature) {
  return callProxy({ mode: 'polygon', polygon: polygonFeature });
}

export async function fetchParcelById(parcelnumb) {
  return callProxy({ mode: 'id', parcelnumb });
}

async function callProxy(body) {
  const resp = await fetch(PROXY_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || `Proxy error (${resp.status})`);
  }

  // Normalize to a GeoJSON FeatureCollection regardless of exact Regrid response shape.
  return normalizeToFeatureCollection(data);
}

function normalizeToFeatureCollection(data) {
  if (!data) return { type: 'FeatureCollection', features: [] };
  if (data.type === 'FeatureCollection') return data;
  if (data.type === 'Feature') return { type: 'FeatureCollection', features: [data] };
  // Regrid sometimes wraps in { parcels: { features: [...] } } or { results: [...] }
  if (data.parcels?.features) return { type: 'FeatureCollection', features: data.parcels.features };
  if (data.features) return { type: 'FeatureCollection', features: data.features };
  if (Array.isArray(data.results)) return { type: 'FeatureCollection', features: data.results };
  return { type: 'FeatureCollection', features: [] };
}
